// ============================================================
// Tabs.js
// Controlled tab strip. The active tab is owned by the caller —
// typically derived from a URL ?tab= query param via
// useSearchParams. This keeps tab state shareable via URL.
//
// Usage:
//   const [params, setParams] = useSearchParams();
//   const active = params.get('tab') || 'users';
//   <Tabs
//     tabs={[{ id: 'users', label: 'Users' }, { id: 'modules', label: 'Modules' }]}
//     active={active}
//     onChange={(id) => setParams(prev => { prev.set('tab', id); return prev; })}
//   />
// ============================================================

import React from 'react';
import './Tabs.css';

export default function Tabs({ tabs, active, onChange }) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`tabs__tab ${isActive ? 'tabs__tab--active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.icon && <span className="tabs__icon">{tab.icon}</span>}
            <span>{tab.label}</span>
            {typeof tab.count === 'number' && (
              <span className="tabs__count">{tab.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
